














































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import eventBus from '@/utils/eventBus';

import {
  IWidgetSettingsFormData,
  WidgetDevice,
  WidgetDirection,
  WidgetNameIcon
} from '@/models/Widget/settings';
import { EWidgetThemes } from '@/models/Widget/themes';

import Typography from '@/components/atoms/Typography/Typography.vue';
import WidgetColorSelect from '@/components/atoms/WidgetColorSelect/WidgetColorSelect.vue';
import WidgetIconSelect from '@/components/atoms/WidgetIconSelect/WidgetIconSelect.vue';
import NumberField from '@/components/atoms/NumberField/NumberField.vue';
import TextInput from '@/components/TextInput/TextInput.vue';
import TextInputMaxCharacter from '@/components/TextInputMaxCharacter/TextInputMaxCharacter.vue';
import RadioGroup from '@/componentsV2/molecules/RadioGroup/RadioGroup.vue';
import CollapseConfig from '@/componentsV2/molecules/CollapseConfig/CollapseConfig.vue';
import PlacementConfigRadio from '@/components/molecules/PlacementConfigRadio/PlacementConfigRadio.vue';
import Tabs, { Tab } from '@/components/molecules/Tabs/Tabs.vue';
import MockupWidgetPreview from '@/componentsV2/organisms/MockupWidgetPreview/MockupWidgetPreview.vue';
import FormLabel from '@/components/molecules/Typography/FormLabel.vue';
import Checkbox from '@/components/Checkbox/Checkbox.vue';
import { configWidgetFormDataFactory } from '@/views/Onboarding/helpers';
import InfoIcon from '@/components/icons/InfoV2.vue';

// ICONS
import VerticalIcon from '@/components/icons/Vertical.vue';
import HorizontalIcon from '@/components/icons/Horizontal.vue';
import { EFeedbackDeactivationType } from '@/models/feedback';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import flagKeys from '@/constants/flagKeys';
import { isExternalOauthSessionOnline } from '@/router/router-utils';

export const DEFAULT_TAB = 'desktop';

@Component({
  components: {
    Typography,
    Checkbox,
    FormLabel,
    WidgetColorSelect,
    WidgetIconSelect,
    MockupWidgetPreview,
    PlacementConfigRadio,
    Tabs,
    NumberField,
    VerticalIcon,
    HorizontalIcon,
    CollapseConfig,
    RadioGroup,
    TextInput,
    InfoIcon,
    TextInputMaxCharacter
  }
})
export default class WidgetConfigForm extends Vue {
  @Prop() defaultFormData?: IWidgetSettingsFormData;
  @Prop({ default: '' }) defaultActiveDeviceTab?: string;
  @Prop({ default: false }) isInternalPage?: boolean;
  @Prop({ default: [] }) errors?: any[];
  @Prop({ default: '' }) description?: string;

  activeDeviceTab = (this.defaultActiveDeviceTab ||
    DEFAULT_TAB) as WidgetDevice;
  formData: IWidgetSettingsFormData =
    this.defaultFormData || configWidgetFormDataFactory();

  widthSettingsHeader = '440px';
  collapseOpened = '';
  hasShowPreview = false;

  radioLauncher: any = [];
  radioVisibility: any = [];

  get tPrefix() {
    return 'common.components.widgetConfigFormV2';
  }

  get flags() {
    return this.$store.getters['flags/getFlags'];
  }

  get isEnableToChangeWelcome() {
    return this.flags.includes('widget-optional-welcome-message');
  }

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get tabs(): Tab[] {
    return [
      {
        key: 'desktop',
        label: String(this.$t(`${this.tPrefix}.labels.desktopPositioning`))
      },
      {
        key: 'mobile',
        label: String(this.$t(`${this.tPrefix}.labels.mobilePositioning`))
      }
    ];
  }

  get isNewOnlineSignup() {
    return isExternalOauthSessionOnline();
  }

  getErrorByName(name: string) {
    if (!this.errors || this.errors.length === 0) return '';

    const element = this.errors.filter(({ value }) => value === name)[0];

    if (!element) return '';
    return element.label;
  }

  myEventHandler() {
    const { offsetWidth } = document.querySelector(
      '.widget-config-form__container-configs'
    ) as HTMLDivElement;
    this.widthSettingsHeader = `${offsetWidth}px`;
  }

  setFormData(formData: IWidgetSettingsFormData) {
    this.formData = formData;
    this.collapseOpened = '';
  }

  created() {
    eventBus.$on('widgetConfigFormSetTab', this.setTab);
    eventBus.$on('widgetConfigFormSetFormData', this.setFormData);
    window.addEventListener('resize', this.myEventHandler);
    this.radioLauncher = [
      {
        value: 'only',
        label: String(this.$t(`${this.tPrefix}.labels.launcher.onlyIcon`))
      },
      {
        value: 'both',
        label: String(this.$t(`${this.tPrefix}.labels.launcher.bothTextIcon`))
      }
    ];
    this.radioVisibility = [
      {
        value: 'desktop',
        label: String(this.$t(`${this.tPrefix}.labels.visibility.desktop`))
      },
      {
        value: 'mobile',
        label: String(this.$t(`${this.tPrefix}.labels.visibility.mobile`))
      },
      {
        value: 'both',
        label: String(this.$t(`${this.tPrefix}.labels.visibility.both`))
      }
    ];
  }

  destroyed() {
    window.removeEventListener('resize', this.myEventHandler);
  }

  beforeDestroy() {
    eventBus.$off('widgetConfigFormSetTab', this.setTab);
    eventBus.$off('widgetConfigFormSetFormData', this.setFormData);
  }

  @Watch('formData', { deep: true })
  onChange() {
    this.$emit('change', {
      ...this.formData,
      imagePreview:
        this.formData.imagePreview ||
        (this.defaultFormData && this.defaultFormData.imagePreview)
    });
  }

  @Watch('formData.enabled')
  canActivate() {
    this.$emit('canActivate', this.formData.enabled);
    if (!this.formData.enabled) {
      this.collapseOpened = '';
      this.hasShowPreview = false;
    }
  }

  handleCollapse(value: string) {
    if (this.collapseOpened === value) {
      this.collapseOpened = '';
      this.formData.previewState = 'popover';
    } else {
      this.collapseOpened = value;
      if (value === 'welcome' && this.formData.welcome.enable) {
        this.formData.previewState = 'welcomeMessage';
      } else {
        this.formData.previewState = '';
      }
    }
  }

  getChangedSection(section: string) {
    const sections = this.$store.getters['business/getWidgetWarnChanges'];

    return sections && sections.includes(section);
  }

  setTab(tabKey: string) {
    this.activeDeviceTab = tabKey as WidgetDevice;
    this.$emit('changeDevice', tabKey);
  }

  handleLauncher(value: string) {
    this.formData.widgetStyle.launcher = value;
    this.formData.previewState = '';
  }

  handleVisibility(value: string) {
    this.formData.welcome.visibility = value;
  }

  handleControlClick(type: string, direction: WidgetDirection) {
    const activeDeviceTab = this.activeDeviceTab as WidgetDevice;

    const controlsMap: Record<string, () => void> = {
      increment: () => {
        const currentValue = this.formData.placement[activeDeviceTab][
          direction
        ];

        if (!currentValue) {
          this.formData.placement[activeDeviceTab][direction] = 1;

          return;
        }

        this.formData.placement[activeDeviceTab][direction]++;
      },
      decrement: () => {
        const currentValue = this.formData.placement[activeDeviceTab][
          direction
        ];

        if (currentValue === 0) return;

        this.formData.placement[activeDeviceTab][direction]--;
      }
    };

    if (!controlsMap[type]) return;

    controlsMap[type]();
  }

  handleChangePlacementField(value: number, direction: WidgetDirection) {
    const activeDeviceTab = this.activeDeviceTab as WidgetDevice;

    this.formData.placement[activeDeviceTab][direction] = value;
  }

  handleChangeActivateWelcome() {
    this.formData.welcome.enable = !this.formData.welcome.enable;
    this.formData.previewState = this.formData.welcome.enable
      ? 'welcomeMessage'
      : '';
  }

  handleChangeActivate() {
    if (
      this.formData.enabled &&
      this.flags.includes(flagKeys.deactivationFeedback) &&
      this.isInternalPage
    ) {
      eventBus.$emit(
        'openSubModal',
        new ModalOptionsV2({
          componentToRender: `deactivationReviewModal${
            this.flags.includes(flagKeys.widgetDeactivationAlerts) ? 'V2' : ''
          }`,
          hideCancelButton: false,
          icon: '',
          mobilePositionBottom: true,
          mobileFullScreen: false
        }),
        {
          type: EFeedbackDeactivationType.WIDGET_DEACTIVATED,
          onSuccess: () => {
            Object.assign(this.formData, { enabled: !this.formData.enabled });
          }
        }
      );
    } else {
      Object.assign(this.formData, { enabled: !this.formData.enabled });
    }
    setTimeout(() => {
      if (this.$refs && this.$refs.tippyRef) {
        (this.$refs.tippyRef as any).tip.show();
      }
    });
  }

  handleColor(colorData: { color: EWidgetThemes }) {
    this.formData.widgetStyle.color = colorData.color;
    this.formData.previewState = 'popover';
  }

  handleIcon(iconData: { icon: WidgetNameIcon }) {
    this.formData.widgetStyle.icon = iconData.icon;
    this.formData.previewState = '';
  }

  handleChangeTab(tab: Tab) {
    this.setTab(tab.key);
  }
}
